import MainVideoBlock from "../../js/components/elements/MainVideoBlock";

if (document.getElementById('main-video-block-vue')) {
    new Vue({
        el: '#main-video-block-vue',
        components: {
            MainVideoBlock
        },
    });
}



// WEBPACK FOOTER //
// ./resources/js/snippets/main_vide_block.js